import React, { useState, Fragment, useEffect } from "react";
import { Listbox, ListboxOptions, ListboxOption, ListboxButton, Transition } from '@headlessui/react'
import { CheckIcon, ChevronDownIcon } from '@heroicons/react/20/solid'
import Icon from "./Icons";

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
  }

function DropDown({
    value,
    options,
    onSelect,
    icon,
    colour
}) {
    const [selected, setSelected] = useState(options[0])

    useEffect(() => {
        const selectedOption = options.filter((option) => {
            return option.id === value;
        });
        console.log('[Form.js] selectedOption', selectedOption);
        if (selectedOption[0]?.id) {
            setSelected(selectedOption[0]);
        } else {
            setSelected(options[0])
        }
    }, [value])

    const handleSelect = (option) => {
        console.log('[Form.js] option', option);
        setSelected(option);
        onSelect(option)
    }

  return (
    <Listbox value={selected} onChange={handleSelect}>
      {({ open }) => (
        <>
          <div className="z-20 p-2">
            <div className={`inline-flex z-20 divide-x divide-${colour ? colour : 'blue'}-900 rounded-md shadow-md w-full sm:w-auto`} >
              <div className={`flex items-center w-full sm:w-auto gap-x-1.5 rounded-l-md ${selected?.id !== null ? `bg-${colour ? colour : 'blue'}-700` : 'bg-white'} px-3 py-2 ${selected?.id !== null ? 'text-white' : `text-${colour ? colour : 'blue'}-700` } shadow-sm`}>
                {selected?.id !== null ? icon : null }
                <p className="text-sm font-title font-semibold">{selected?.name}</p>
              </div>
              <ListboxButton className={`inline-flex items-center rounded-l-none rounded-r-md bg-${colour ? colour : 'blue'}-700 p-2 hover:bg-${colour ? colour : 'blue'}-900 focus:outline-none focus:ring-2 focus:ring-${colour ? colour : 'blue'}-700 focus:ring-offset-2 focus:ring-offset-gray-50`}>
                <ChevronDownIcon className="h-5 w-5 text-white" aria-hidden="true" />
              </ListboxButton>
            </div>

            <Transition
              show={open}
              as={Fragment}
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <ListboxOptions anchor="bottom" className="absolute z-50 mt-2 w-80 md:w-72 max-h-[400px] overflow-y-auto divide-y divide-gray-200 overflow-hidden rounded-md bg-white shadow-xl ring-1 ring-black ring-opacity-5 focus:outline-none">
                {options?.map((option) => (
                  <ListboxOption
                    key={option?.id}
                    className={({ active }) =>
                      classNames(
                        active ? 'bg-plum-300 ' : '',
                        'text-plum-900 cursor-default select-none p-4 text-sm z-50'
                      )
                    }
                    value={option}
                  >
                    {({ selected, active }) => (
                      <div className="flex flex-col">
                        <div className="flex justify-between font-title">
                          <p className={'font-semibold text-[15px]'}>{option?.name}</p>
                          {option?.icon ? (
                            <span className={`text-${colour ? colour : 'blue'}-700`}>
                              <Icon className="h-5 w-5" aria-hidden="true" type={option?.name} colour={'#3797D3'} />
                            </span>
                            )
                            : selected ? (
                            <span className={`text-${colour ? colour : 'blue'}-700`}>
                              <CheckIcon className="h-5 w-5" aria-hidden="true" />
                            </span>
                          ) : null}
                        </div>
                      </div>
                    )}
                  </ListboxOption>
                ))}
              </ListboxOptions>
            </Transition>
          </div>
        </>
      )}
    </Listbox>
  )
}

export {
    DropDown
}